import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Zap, ArrowLeft } from 'lucide-react';

const CookiesPage = () => {
  return (
    <div style={{backgroundColor: '#F7F8FA', color: '#1e293b'}} className="min-h-screen">
      {/* Navigation */}
      <nav style={{backgroundColor: '#ffffff'}} className="border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-9 h-9 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center">
                <Zap className="h-5 w-5 text-white" />
              </div>
              <span style={{color: '#1e293b'}} className="text-xl font-bold">SmartFacture AI</span>
            </Link>
            <Link to="/">
              <Button variant="ghost" style={{color: '#475569'}}>
                <ArrowLeft className="h-4 w-4 mr-2" />
                Retour
              </Button>
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 style={{color: '#1e293b'}} className="text-3xl font-bold mb-8">Politique de Cookies</h1>
        
        <div style={{backgroundColor: '#ffffff'}} className="rounded-2xl p-8 shadow-sm space-y-8">
          
          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">1. Qu'est-ce qu'un cookie ?</h2>
            <p style={{color: '#475569'}}>
              Un cookie est un petit fichier texte stocké sur votre appareil (ordinateur, smartphone, tablette) 
              lorsque vous visitez un site web. Les cookies permettent au site de mémoriser vos actions et préférences 
              pendant une durée déterminée.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">2. Cookies utilisés par SmartFacture AI</h2>
            
            <h3 style={{color: '#1e293b'}} className="text-lg font-medium mt-4 mb-2">Cookies strictement nécessaires</h3>
            <p style={{color: '#475569'}}>
              Ces cookies sont essentiels au fonctionnement du site et ne peuvent pas être désactivés.
            </p>
            <div style={{backgroundColor: '#f8fafc'}} className="rounded-lg p-4 mt-2">
              <table className="w-full text-sm">
                <thead>
                  <tr style={{color: '#64748b'}}>
                    <th className="text-left pb-2">Nom</th>
                    <th className="text-left pb-2">Finalité</th>
                    <th className="text-left pb-2">Durée</th>
                  </tr>
                </thead>
                <tbody style={{color: '#475569'}}>
                  <tr>
                    <td className="py-1">auth_token</td>
                    <td className="py-1">Authentification utilisateur</td>
                    <td className="py-1">Session</td>
                  </tr>
                  <tr>
                    <td className="py-1">cookie_consent</td>
                    <td className="py-1">Mémorisation de votre choix cookies</td>
                    <td className="py-1">1 an</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 style={{color: '#1e293b'}} className="text-lg font-medium mt-6 mb-2">Cookies de performance (optionnels)</h3>
            <p style={{color: '#475569'}}>
              Ces cookies nous aident à comprendre comment les visiteurs utilisent notre site.
            </p>
            <div style={{backgroundColor: '#f8fafc'}} className="rounded-lg p-4 mt-2">
              <table className="w-full text-sm">
                <thead>
                  <tr style={{color: '#64748b'}}>
                    <th className="text-left pb-2">Nom</th>
                    <th className="text-left pb-2">Finalité</th>
                    <th className="text-left pb-2">Durée</th>
                  </tr>
                </thead>
                <tbody style={{color: '#475569'}}>
                  <tr>
                    <td className="py-1">_ga</td>
                    <td className="py-1">Google Analytics - statistiques</td>
                    <td className="py-1">2 ans</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">3. Gestion des cookies</h2>
            <p style={{color: '#475569'}}>
              Lors de votre première visite, une bannière vous permet d'accepter ou de refuser les cookies optionnels.
              Vous pouvez modifier vos préférences à tout moment :
            </p>
            <ul style={{color: '#475569'}} className="list-disc ml-6 mt-2 space-y-1">
              <li>En cliquant sur le lien "Gérer les cookies" en bas du site</li>
              <li>En modifiant les paramètres de votre navigateur</li>
            </ul>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">4. Comment désactiver les cookies dans votre navigateur</h2>
            <ul style={{color: '#475569'}} className="list-disc ml-6 space-y-1">
              <li><strong>Chrome :</strong> Paramètres → Confidentialité et sécurité → Cookies</li>
              <li><strong>Firefox :</strong> Options → Vie privée et sécurité → Cookies</li>
              <li><strong>Safari :</strong> Préférences → Confidentialité → Cookies</li>
              <li><strong>Edge :</strong> Paramètres → Cookies et autorisations de site</li>
            </ul>
            <p style={{color: '#475569'}} className="mt-2">
              Note : La désactivation des cookies essentiels peut empêcher le bon fonctionnement du site.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">5. Modifications</h2>
            <p style={{color: '#475569'}}>
              Cette politique de cookies peut être mise à jour. Nous vous invitons à la consulter régulièrement.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">6. Contact</h2>
            <p style={{color: '#475569'}}>
              Pour toute question concernant notre utilisation des cookies, contactez-nous à :{' '}
              <strong>contact@smartfacture-ai.com</strong>
            </p>
          </section>

          <p style={{color: '#94a3b8'}} className="text-sm mt-8">
            Dernière mise à jour : Février 2026
          </p>
        </div>
      </main>
    </div>
  );
};

export default CookiesPage;
